import React from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface SwipeableDrawerProps {
  open: boolean;
  onClose: () => void;
  onOpen: () => void;
  anchor?: 'top' | 'left' | 'bottom' | 'right';
  customWidth?: any;
  children: React.ReactNode;
}

export const CustomSwipeableDrawer: React.FC<SwipeableDrawerProps> = ({
  open,
  onClose,
  onOpen,
  anchor = 'left',
  customWidth,
  children,
}) => (
  <SwipeableDrawer anchor={anchor} open={open} onClose={onClose} onOpen={onOpen}>
    <Box sx={{ width: anchor === 'top' || anchor === 'bottom' ? '100%' : customWidth, p: 2 }}>
      <IconButton
        onClick={onClose}
        sx={{ position: 'absolute', right: 8, top: 8, zIndex: 99999999 }}
      >
        <CloseIcon />
      </IconButton>
      <Box>{children}</Box>
    </Box>
  </SwipeableDrawer>
);

CustomSwipeableDrawer.defaultProps = {
  anchor: 'left',
  customWidth: 350,
};
